export default function CTA() {
  return (
    <section className="mx-auto max-w-7xl px-4 py-16 md:px-6 md:py-24">
      <div className="relative overflow-hidden rounded-3xl px-6 py-14 text-center md:py-20">
        <div
          className="absolute inset-0 bg-cover bg-center"
          style={{
            backgroundImage:
              "url('https://readdy.ai/api/search-image?query=A%20soft%20anime%20illustration%20of%20cherry%20blossom%20petals%20floating%20against%20a%20warm%20peach%20sunset%20sky%2C%20gentle%20blurred%20branches%20in%20the%20corner%2C%20romantic%20dreamy%20pink%20and%20coral%20palette%2C%20clean%20stylized%20anime%20background%20art%2C%20smooth%20soft%20gradient%2C%20peaceful%20ethereal%20mood&width=1600&height=700&seq=cta-sakura-petals&orientation=landscape')",
          }}
        />
        <div className="absolute inset-0 bg-primary-950/40" />

        <div className="relative flex flex-col items-center">
          <h2 className="font-heading text-2xl font-bold text-white md:text-4xl">
            现在就开始，追更从此不怕漏
          </h2>
          <p className="mt-3 max-w-xl text-sm leading-relaxed text-white/90 md:text-base">
            免费收藏订阅，更新第一时间提醒，缓存下载随时离线看。你的追更清单，值得被好好对待。
          </p>
          <div className="mt-7 flex w-full flex-col items-center gap-3 sm:w-auto sm:flex-row">
            <a
              href="#top"
              className="inline-flex w-full items-center justify-center gap-2 whitespace-nowrap rounded-full bg-background-50 px-8 py-3.5 text-sm font-semibold text-primary-700 transition-colors hover:bg-primary-100 sm:w-auto"
            >
              <i className="ri-bookmark-3-line text-base" />
              收藏你的第一部作品
            </a>
            <a
              href="#trending"
              className="inline-flex w-full items-center justify-center gap-2 whitespace-nowrap rounded-full bg-white/15 px-8 py-3.5 text-sm font-semibold text-white ring-1 ring-white/40 backdrop-blur-sm transition-colors hover:bg-white/25 sm:w-auto"
            >
              看看热门追更
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}